import { useAuth0 } from '@auth0/auth0-react';
import PreSchoolService from 'Lib/API/PreSchool';
import closeIcon from "assets/icons/close-primary.svg";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";

import { CircularProgress } from '@mui/material';
import { MyCheckbox } from 'components/MyCheckbox';

import { useSearch } from "hook";
import React, { useEffect } from 'react';
import { toastr } from 'react-redux-toastr';
import { BeatLoader } from 'react-spinners';
import AddParticipantModalMembers from './AddParticipantModalMembers';
import { AddParticipantModalActions, AddParticipantModalButton, AddParticipantModalCheckbox, AddParticipantModalCheckboxLabel, AddParticipantModalClose, AddParticipantModalContainer, AddParticipantModalContent, AddParticipantModalContentLabel, AddParticipantModalField, AddParticipantModalHeader, AddParticipantModalTitle, LoadingContainer, Selection, SelectionActiveValue, SelectionActiveValueName, SelectionActiveValueNumber, SelectionArrow, SelectionInput } from './Theme';
const AddParticipantModal = ({
  closeModal,
  formId,
  addParticipantHandler,
  addParticipantLoading
}) => {
  const selectionRef = React.useRef(null);
  const participantsRef = React.useRef(null);
  const selectionInputRef = React.useRef(null);

  const { getAccessTokenSilently } = useAuth0();
  const [participants, setParticipants] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState('')
  const [searchText, setSearchText] = React.useState('');
  const { searchAction } = useSearch({ action: setSearchValue });
  const [showMembers, setShowMembers] = React.useState(false);
  const [activeParticipant, setActiveParticipant] = React.useState({});
  const [generateCharges, setGenerateCharges] = React.useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (participantsRef.current && !participantsRef.current.contains(event.target) && selectionRef.current && !selectionRef.current.contains(event.target)) {
        resetSearchSelection()
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [participantsRef]);
  

  const getClassParticipantsAccountsHandler = async () => {
    setIsLoading(true)
    const token = await getAccessTokenSilently();
    PreSchoolService.getClassParticipantsAccounts(token, formId, searchValue).then((response) => {
      setParticipants(response?.result || [])
    }).catch((error) => {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    }).finally(() => {
      setIsLoading(false)
    })
  }

  useEffect(() => {
    getClassParticipantsAccountsHandler()
  }, [searchValue]);

  const selectParticipantHandler = (account,memberId) => {
    const participant = {
      ...account,
      memberId,
    }
    setActiveParticipant(participant)
    resetSearchSelection()
  }

  const resetSearchSelection = () => {
    setSearchText("")
    setSearchValue("")
    setShowMembers(false)

  }
  
  const onAddParticipantClick = async () => {
    addParticipantHandler({
      contactId: activeParticipant?.id,
      doNotCreateCharge: generateCharges,
      firstName: activeParticipant?.first_name,
      lastName: activeParticipant?.last_name,
    })
  }



  return (
    <AddParticipantModalContainer>
      <AddParticipantModalClose
        onClick={() => closeModal()}
      >
        <img src={closeIcon} alt="" />
      </AddParticipantModalClose>
      <AddParticipantModalHeader>
        <AddParticipantModalTitle>Add New Student</AddParticipantModalTitle>
      </AddParticipantModalHeader>
      <AddParticipantModalContent>
        <AddParticipantModalField>
          <AddParticipantModalContentLabel>
          Search by family name
          </AddParticipantModalContentLabel>

        <Selection
          ref={selectionRef}
          onClick={() => {
            if (isLoading) return;
            if(!showMembers && selectionInputRef?.current) {
              selectionInputRef.current.focus();
            } 
            setShowMembers((prev) => !prev);
          }}
          isActive={showMembers}
        
        >
         
          <SelectionInput 
              ref={selectionInputRef}
              // placeholder="Select ID/Name" 
              onChange={(event) => {
                const {value} = event.target;
                searchAction(value);
                setSearchText(value);
                setShowMembers(true);
              }}
              value={searchText}
              width={searchText && "100%"}
          />
           {!searchText && (
            <SelectionActiveValue>
              {(activeParticipant?.first_name || activeParticipant?.last_name) ?
              (
                <>
                <SelectionActiveValueName>
                    {`${activeParticipant?.first_name} ${activeParticipant?.last_name}`}
                </SelectionActiveValueName>
                <SelectionActiveValueNumber>
                    #{activeParticipant?.member_id}
                </SelectionActiveValueNumber>
                </>
              )
               : "Select ID/Name"}
            </SelectionActiveValue>
          )}
        
          {isLoading && (
            <LoadingContainer>
              <BeatLoader size={8} color="#C1CEF9" />
            </LoadingContainer>
          )}
          <SelectionArrow>
            <BottomArrowSvg label="Emoji" />
          </SelectionArrow>
        </Selection>
        {showMembers && (
          <AddParticipantModalMembers 
            members={participants} 
            isLoading={isLoading}
            selectParticipantHandler={selectParticipantHandler}
            activeParticipant={activeParticipant}
            participantsRef={participantsRef}
          />
        )}
        </AddParticipantModalField>
          <AddParticipantModalField>
            <AddParticipantModalCheckbox>
            <MyCheckbox
                handlechange={(e) =>{
                  setGenerateCharges(e.target.checked)
                }}
                checked={generateCharges}
                name={`generateCharges`}
                title={"Do not generate charges"}
            />
            </AddParticipantModalCheckbox>
        </AddParticipantModalField>
      </AddParticipantModalContent>
      <AddParticipantModalActions>
        <AddParticipantModalButton secondary
          onClick={() => closeModal()}
        >Cancel</AddParticipantModalButton>
        <AddParticipantModalButton primary
          onClick={() => onAddParticipantClick()}
          disabled={!activeParticipant?.id}
        >
          {addParticipantLoading ?  <CircularProgress size={20} 
             style={{
              color: "#FFFFFF",
            }}
          /> : "Add Student"}
        </AddParticipantModalButton>
      </AddParticipantModalActions>
    </AddParticipantModalContainer>
  )
}

export default AddParticipantModal